/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsForAws extends models.LocationDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LocationDetailsForAws");
    }

    getFixupPrototypeFunction() { return LocationDetailsForAws.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsForAws>): LocationDetailsForAws {
        let obj = Object.assign(new LocationDetailsForAws(), model);
        LocationDetailsForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsForAws>): LocationDetailsForAws {
        if (!model) return null;
        return LocationDetailsForAws.newInstance(<LocationDetailsForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsForAws) {
        if (!obj) return;

        models.LocationDetailsForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsForAws): boolean {
        if (models.LocationDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationDetailsForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
